<template>
  <iframe :src="iframeSrc" style="height: 100vh; width: 100vw;"></iframe>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: '',
    };
  },
  created() {
    // Set the iframe source dynamically
    const queryString = window.location.search;
    this.iframeSrc = `/aliff/index.html${queryString}`;

    // Add Meta Pixel, Google Tag Manager, and noscript dynamically
    this.addMetaPixel();
    this.addGoogleTagManager();
    this.addGoogleTagManagerNoscript();
  },
  methods: {
    addMetaPixel() {
      const script = document.createElement('script');
      script.text = `
        !function(f,b,e,v,n,t,s) {
          if(f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if(!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '876421340972288');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=876421340972288&ev=PageView&noscript=1" />
      `;
      document.head.appendChild(noscript);
    },
    addGoogleTagManager() {
      const script = document.createElement('script');
      script.text = `
        (function(w,d,s,l,i) {
          w[l] = w[l] || [];
          w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-KCWC87C5');
      `;
      document.head.appendChild(script);
    },
    addGoogleTagManagerNoscript() {
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KCWC87C5"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(noscript);
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/StudyAbroad.vue